






























































































































































































































































































































































































































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import FormatDate from '@/helpers/FormatDate'
import PreviewText from '@/helpers/PreviewText'
import CheckDevice from '@/helpers/CheckDevice'
import CheckFileFormat from '@/helpers/CheckFileExtension'
import GroupService from '@/services/GroupService'
import GroupTopicService from '@/services/GroupTopicService'
import CommonTopicService from '@/services/CommonTopicService'
import CommonSharedFolderService from '@/services/CommonSharedFolderService'
import { runDownload, downloadLabel, revokeObjectUrlLater } from '@/helpers/FileDownload'
import ModalLikers from '@/components/Modal/ModalLikers.vue'
import ModalCommentRoot from '@/components/Modal/ModalCommentRoot.vue'
import ModalFullImageViewer from '@/components/Modal/ModalFullImageViewer.vue'
import ModalShowProfile from '@/components/Modal/ModalShowProfile.vue'
import TopicCommentArea from '@/views/Group/TopPage/NewFeed/TopicCommentArea.vue'
import LoadingTopicComment from '@/components/Loading/LoadingTopicComment.vue'
import {
  EFileFormat,
  EUserStatus,
  Topic,
  TopicAttachFile,
  TopicComment,
  TopicCommentParams,
  TopicDetails,
  TopicLiker
} from '@/models'
import {commentRef} from '@/firebase'
import updateGroupMaxFileSize from '@/helpers/UpdateGroupMaxFileSize'
import {EhumbNailsDisplay} from '@/models/Setting/Enum'
import linkifyHtml from "linkify-html";
import EmojiPopup from '@/components/EmojiPopup.vue'
import {allItemMention, getMentionIdsFromContent} from '@/helpers/Mentions'
import {
  decodeHtml,
  escapeHtml,
  extractContentFromContentEditableOrTiny,
  getEmojiByNativeFunc,
  getInlineEditorImageSrcFromClick,
  handleTranslation,
  hanldeUserStatus,
  stripHtmlKeepFormat
} from '@/helpers/Common'
import {MAX_USER_DISPLAY, TRANSLATION_TYPE} from '@/constants'
// @ts-ignore
import {Emoji} from 'emoji-mart-vue-fast'

@Component({
  components: {
    TopicCommentArea,
    ModalShowProfile,
    ModalLikers,
    ModalCommentRoot,
    ModalFullImageViewer,
    LoadingTopicComment,
    EmojiPopup,
    Emoji
  }
})
export default class TopicDetailComment extends Vue {
  //start screen
  @Prop() ableComment!: boolean
  @Prop() isInBin!: boolean
  @Prop() emojiIndex: any
  @Prop() currentTopic!: Topic
  private topicDetail: TopicDetails = new TopicDetails()
  roleEditTopic: boolean = false
  private allowAnonymous!: boolean
  enableLike!: boolean
  hideLiker!: boolean
  likeText: string = this.$t('groups.nav_button.like') as string
  isCommonTopic = !this.$route.params.groupId
  maxUserDisplay: number = MAX_USER_DISPLAY
  maxFileSize: any = {
    mb: this.isCommonTopic
      ? 25
      : Number(this.$store.state.userInfo.user.current_group_max_file_size),
    bytes: this.isCommonTopic
      ? 25 * 1048576
      : Number(this.$store.state.userInfo.user.current_group_max_file_size) *
        1048576
  }
  private isTyping: boolean = false
  private isTypingReply: any[] = []
  displayThumbnail: boolean =
    this.$store.state.setting.setting.setting_display.display_image_video ===
    EhumbNailsDisplay.DISPLAY_THUMBNAILS
  readerListModal: any[] = []
  readerListShowEmoji: boolean = false
  readerListLoading: boolean = false
  errorMess: string = ''

  //data
  currentComments: TopicComment[] = []
  commentById: TopicComment = new TopicComment()
  eFileFormat = EFileFormat
  eUserStatus = EUserStatus
  commentSortNew: boolean = true

  //API helper
  page: number = 1
  lastPage: number = 1
  private searchPage: number = 1
  private pageUp: number = 1
  private pageDown: number = 1
  private isPageUp: boolean = false
  private isPageDown: boolean = false
  loadMoreUp: boolean = false
  disablePageUp: boolean = false
  disablePageDown: boolean = false
  private limitComment: number = this.$store.state.setting.setting
    .setting_display.number_items_list_comment
  currentUser = this.$store.state.userInfo.user.info

  //view model
  private justSubmitNewComment: boolean = false
  replyCommentId: number = 0
  replyCommentIdCollapse: number = 0
  commenterId: number = -1
  blinkCommentId: number = -1
  fullOverviewSrc: string = ''
  noAvatar = require('@/assets/images/avatar-default.png')
  isLoading: boolean = true
  unreadCommentIdStart: number = 0
  unreadCommentIdEnd: number = 0
  private unsubscribe: any = () => {}
  canOpenFullImageModal: boolean = false

  created() {
    this.init()
  }

  destroyed() {
    if (this.unsubscribe) {
      this.unsubscribe()
    }
  }

  mounted() {
    this.$bus.$on('updateComment', this.updateCommentAfterRead)
  }

  beforeDestroy() {
    this.$bus.$off('updateComment', this.updateCommentAfterRead)
  }

  updateCommentAfterRead(commentId: number) {
    this.refreshCommentReadUsersOnly(commentId)
  }

  async refreshCommentReadUsersOnly(commentId: number) {
    if (!commentId) return

    const currentComment = this.currentComments.find(c => c.id === commentId)
    if (!currentComment) return

    await this.getCommentById(commentId, true)
    if (!this.commentById?.id) return

    this.$set(currentComment, 'users_read', this.commentById.users_read || [])
    this.$set(
      currentComment,
      'users_read_subtract',
      this.commentById.users_read_subtract || 0
    )
    this.$set(
      currentComment,
      'total_users_read',
      this.commentById.total_users_read || 0
    )
  }

  isDisabledTranslate(comment: TopicComment) {
    return comment.is_deleted || comment.attach_file.length > 0 && !comment.content
  }

  handleCommentRealtime() {
    let trackingRealtime = true
    const start = this.moment()
      .subtract(1, 'm')
      .toDate()
    this.unsubscribe = commentRef
      .where('topicId', '==', this.$route.params.topicId)
      .where('createdAt', '>', start)
      .onSnapshot((querySnapshot: any) => {
        if (trackingRealtime) {
          trackingRealtime = false
        } else if (!querySnapshot.docChanges().empty) {
            querySnapshot.docChanges().forEach(async (change: any) => {
              if (change.type === 'added') {
                const newCommentId = change.doc.data().commentIds[0]
                if (newCommentId) {
                  await this.getCommentById(newCommentId)
                  this.$emit('handleMarkRead', true)
                }
              }
            })
          }
      })
  }

  @Watch('currentTopic')
  onCurrentTopicChange(newTopic: Topic) {
    this.setCurrentTopic(newTopic)
  }

  @Watch('$route.query.commentSearchId')
  watchCommentSearchId() {
    if (!this.$route.query.commentSearchId) return
    this.init()
  }

  @Watch('$route.params.topicId')
  async init() {
    this.reset()
    this.handleMaxFileSize()
    this.setCurrentTopic(this.currentTopic)
    await Promise.allSettled([this.getUnreadCommentIdEnd(), this.getAllComments(this.page)])
    this.handleRoleEditTopic()
    this.handleModalCommentParent()
    this.handleCommentRealtime()
  }

  reset() {
    this.page = 1
    this.lastPage = 1
    this.searchPage = 1
    this.pageUp = 1
    this.pageDown = 1
    this.isPageUp = false
    this.isPageDown = false
    this.loadMoreUp = false
    this.disablePageUp = false
    this.disablePageDown = false
    this.justSubmitNewComment = false
    this.replyCommentId = 0
    this.replyCommentIdCollapse = 0
    this.commenterId = -1
    this.blinkCommentId = -1
    this.isLoading = true
    this.unreadCommentIdStart = 0
    this.unreadCommentIdEnd = 0
    this.unsubscribe()
  }

  handleCommentStatus(status: boolean) {
    this.isTyping = status
    this.emitConfirmLeave()
  }

  handleCommenReplyStatus(status: boolean, conmmentId: number) {
    const finder = this.isTypingReply.find(item => item.id === conmmentId)
    if (finder) {
      const index = this.isTypingReply.indexOf(finder)
      this.isTypingReply[index].status = status
    } else {
      this.isTypingReply.push({ id: conmmentId, status: status })
    }
    this.emitConfirmLeave()
  }

  @Watch('$store.state.userInfo.user.group_role')
  handleRoleEditTopic() {
    if (this.isCommonTopic) {
      this.roleEditTopic = false
      // this.currentTopic.creater_id === this.$store.state.userInfo.user.info.id
    } else {
      this.roleEditTopic = this.$store.state.userInfo.user.group_role.role_edit_topic
    }
  }

  emitConfirmLeave() {
    this.$emit(
      'confirmLeave',
      this.isTyping ||
        (this.isTypingReply.length
          ? this.isTypingReply.every(item => item.status)
          : false)
    )
  }

  @Watch('commentSortNew')
  sortCommnet() {
    this.page = 1
    this.pageUp = 1
    this.pageDown = 1
    this.searchPage = 1
    this.getAllComments(this.page)
  }

  @Watch('$route.query.commentId')
  async handleModalCommentParent() {
    if (this.$route.query.commentId && this.topicDetail.topic_title) {
      await this.getCommentById(Number(this.$route.query.commentId), true)
      this.$bvModal.show('parent-comment-modal')
      this.$router.replace({ query: {} }).catch(() => {})
    }
  }

  async handleMaxFileSize() {
    await updateGroupMaxFileSize(this.$route.params.groupId)
    this.maxFileSize = {
      mb: this.isCommonTopic
        ? 25
        : Number(this.$store.state.userInfo.user.current_group_max_file_size),
      bytes: this.isCommonTopic
        ? 25 * 1048576
        : Number(this.$store.state.userInfo.user.current_group_max_file_size) *
          1048576
    }
  }

  /**
   * get all comments
   */
  async getAllComments(
    page: number,
    loadMore?: boolean,
    isLoadMoreUp?: boolean
  ) {

    this.page = page

    if (this.isCommonTopic) {
      await this.getAllCommonTopicComments(page, loadMore, isLoadMoreUp)
    } else {
      await this.getAllGroupTopicComments(page, loadMore, isLoadMoreUp)
    }

    //if page is min (=1) disable page up forever
    this.disablePageUp = this.page === 1

    //if page is max (= lastPage) disable page down forever
    this.disablePageDown = this.page === this.lastPage
  }

  setCurrentTopic(topic: Topic) {
    this.topicDetail = topic.topic_detail
    this.allowAnonymous = this.topicDetail.allow_anonymous_comment
    this.enableLike = this.topicDetail.enable_like
    this.hideLiker = this.topicDetail.hide_liker
    this.likeText = this.topicDetail.like_character_change || this.$t('groups.nav_button.like') as string
    this.unreadCommentIdStart = this.topicDetail.last_seen_comment_id
      ? this.topicDetail.last_seen_comment_id
      : 1
  }

  /**
   * get all comments
   */
  async getUnreadCommentIdEnd() {
    if (this.isCommonTopic) {
      return CommonTopicService.getLatestCommentByCommonTopicId({
        topic_id: this.$route.params.topicId,
      }).then(res => {
        if (res.status === 200 && res.data.data.length) {
          if (!res.data.data[0].is_deleted)
          this.unreadCommentIdEnd = res.data.data[0].id
        }
      })
    } else {
      return GroupTopicService.getLatestCommentByTopicId({
        group_id: this.$route.params.groupId,
        topic_id: this.$route.params.topicId,
      }).then(res => {
        if (res.status === 200 && res.data.data.length) {
          if (!res.data.data[0].is_deleted)
          this.unreadCommentIdEnd = res.data.data[0].id
        }
      })
    }
  }

  /**
   * Call API get all comments of group topic
   */
  async getAllGroupTopicComments(
    page: number,
    loadMore?: boolean,
    isLoadMoreUp?: boolean
  ) {
    this.isLoading = true
    return GroupTopicService.getAllCommentByTopicId({
      group_id: this.$route.params.groupId,
      topic_id: this.$route.params.topicId,
      order_by: 'created_at',
      sorted_by: this.commentSortNew ? 'desc' : 'asc',
      is_commenter_hidden: this.allowAnonymous ? 1 : 0,
      page: page,
      limit_comment: this.limitComment,
      comment_id: this.$route.query.commentSearchId
        ? (this.$route.query.commentSearchId as string)
        : ''
    })
      .then(res => {
        if (res.status === 200) {
          this.handleAfterGetAllComment(res, loadMore, isLoadMoreUp)
        }
      })
      .catch(err => (this.$parent as any).handleTopicNotFound(err))
      .finally(() => (this.isLoading = false))
  }

  /**
   * Call API get all comments of common topic
   */
  async getAllCommonTopicComments(
    page: number,
    loadMore?: boolean,
    isLoadMoreUp?: boolean
  ) {
    this.isLoading = true
    return CommonTopicService.getAllCommentByCommonTopicId({
      topic_id: this.$route.params.topicId,
      order_by: 'created_at',
      sorted_by: this.commentSortNew ? 'desc' : 'asc',
      is_commenter_hidden: this.allowAnonymous ? 1 : 0,
      page: page,
      limit_comment: this.limitComment,
      comment_id: this.$route.query.commentSearchId
        ? (this.$route.query.commentSearchId as string)
        : ''
    })
      .then(res => {
        this.handleAfterGetAllComment(res, loadMore, isLoadMoreUp)
      })
      .catch(err => (this.$parent as any).handleTopicNotFound(err))
      .finally(() => (this.isLoading = false))
  }

  /**
   * Hanlde after call API get all comment
   */
  handleAfterGetAllComment(
    res: any,
    loadMore?: boolean,
    isLoadMoreUp?: boolean
  ) {
    if (res.status === 200) {
      //handle page
      this.lastPage = res.data.last_page

      //handle data
      const data = res.data.data.map((item: any) => new TopicComment(item))

      if (loadMore) {
        //handle data
        let loadMoreData = data.filter((item: any) => {
          // filter comment has been deleted
          let existIndex = this.currentComments.findIndex(comment =>
              comment.id == item.id
          )

          if (existIndex == -1)
          return new TopicComment(item)
        })

        this.currentComments = isLoadMoreUp
          ? [...loadMoreData, ...this.currentComments]
          : [...this.currentComments, ...loadMoreData]
      } else {
        this.currentComments = data
      }

      // handle scroll to searchCommentId
      if (this.$route.query.commentSearchId) {
        this.page = res.data.page
        this.pageUp = res.data.page
        this.pageDown = res.data.page
        this.searchPage = res.data.page
        this.disablePageDown = this.page === this.lastPage
        this.disablePageUp = this.page === 1
        this.loadMoreUp = res.data.page !== 1

        //scroll
        this.justSubmitNewComment = true

        this.$nextTick(() => {
          this.handleCommentBlink(Number(this.$route.query.commentSearchId))
          setTimeout(() => {
            this.$router.replace({ query: {} }).catch(() => {})
          }, 1000)
        })
      }

      this.$emit('setTotalComment', res.data.total)
    }
  }

  /**
   * Call API to get comment just add
   */
  async getCommentById(commentId: number, noHandleAfter?: boolean) {
    if (this.isCommonTopic) {
      return CommonTopicService.getCommonTopicCommentById(commentId)
        .then(res => {
          if (res.status === 200) {
            let data = res.data
            if (this.allowAnonymous) {
              data.commenter_name = ''
              data.commenter_avatar = ''
            }
            this.commentById = new TopicComment(data)
            if (noHandleAfter !== true) {
              this.handleAfterAddComment(commentId)
            }
          }
        })
        .catch(err => (this.$parent as any).handleTopicNotFound(err))
    } else {
      return GroupTopicService.getCommentById(
        this.$route.params.groupId,
        commentId
      )
        .then(res => {
          if (res.status === 200) {
            let data = res.data
            if (this.allowAnonymous) {
              data.commenter_name = ''
              data.commenter_avatar = ''
            }
            this.commentById = new TopicComment(data)
            if (noHandleAfter !== true) {
              this.handleAfterAddComment(commentId)
            }
          }
        })
        .catch(err => (this.$parent as any).handleTopicNotFound(err))
    }
  }

  handleAfterAddComment(commentId: number) {
    if (this.commentSortNew) {
      this.currentComments = [
        this.commentById,
        ...this.currentComments.filter(c => c.id !== this.commentById.id)
      ]
      this.$nextTick(() => {
        this.handleCommentBlink(commentId)
      })
    } else {
      const lastestComment = this.currentComments[
        this.currentComments.length - 1
      ]
      if (this.commentById.no === lastestComment.no + 1) {
        this.currentComments = [
          ...this.currentComments.filter(c => c.id !== this.commentById.id),
          this.commentById
        ]
        this.$nextTick(() => {
          this.handleCommentBlink(commentId)
        })
      } else {
        this.$nextTick(() => {
          this.handleCommentBlink(lastestComment.id, true)
        })
      }
    }
  }

  handleCommentBlink(commentId: number, noBlink?: boolean) {
    if (this.justSubmitNewComment) {
      ;(this.$refs[`comment-${commentId}`] as any)[0]?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest'
      })
    }
    if (noBlink !== true) {
      this.blinkCommentId = commentId
    }
    setTimeout(() => {
      this.blinkCommentId = -1
      this.justSubmitNewComment = false
    }, 800)
  }

  /**
   * Call API for loadmore
   */
  loadMore() {
    //if last loadmore is page up -> set current page to last page down
    if (this.isPageUp) this.page = this.pageDown

    //set loadmore to page down
    this.isPageDown = true

    //re-count page
    ++this.page

    //if current page is search page (search page is have data loaded at screen start), continues re-count
    if (this.page === this.searchPage) ++this.page

    //set last page down = this current page
    this.pageDown = this.page

    //if page is max (= lastPage) disable page down forever
    this.disablePageDown = this.page === this.lastPage

    //call API to get data
    this.getAllComments(this.page, true)
  }

  hanldeLoadMoreUp() {
    //if last loadmore is page down -> set current page to last page up
    if (this.isPageDown) this.page = this.pageUp

    //set loadmore to page up
    this.isPageUp = true

    //re-count page
    --this.page

    //if current page is search page (search page is have data loaded at screen start), continues re-count
    if (this.page === this.searchPage) --this.page

    //set last page up = this current page
    this.pageUp = this.page

    //if page is min (=1) disable page up forever
    this.disablePageUp = this.page === 1

    //call API to get data
    this.getAllComments(this.page, true, true)
  }

  /**
   * Sort comment by newest or older
   */
  handleSortComment() {
    this.commentSortNew = !this.commentSortNew
  }

  addEmoji(emoji: any, index: number) {
    this.handleLikeComment(emoji.native, index)
  }

  getLikerEmoji(comment: TopicComment) {
    const userLiker = comment.liker.find(item => item.id === this.$store.state.userInfo.user.profile.user_id)
    return userLiker?.emoji_id || ''
  }

  /**
   * Call API for like or dislike comment
   */
  handleLikeComment(emojiId: string, index: number) {
    this.$blockui.show()
    const payload = {
      emoji_id: emojiId
    }
    let currentCmt = this.currentComments[index]
    if (this.isCommonTopic) {
      CommonTopicService.markAsLikeCommonTopicComment(
        this.$route.params.topicId,
        currentCmt.id,
        payload
      )
        .then(res => {
          if (res.status === 200) {
            this.handleAfterLikeComment(currentCmt, emojiId, res.data)
          }
        })
        .catch(err => {
          ;(this.$parent as any).handleTopicNotFound(err)
        })
        .finally(() => this.$blockui.hide())
    } else {
      GroupTopicService.markAsLikeComment(
        this.$route.params.groupId,
        this.$route.params.topicId,
        currentCmt.id,
        payload
      )
        .then(res => {
          if (res.status === 200) {
            this.handleAfterLikeComment(currentCmt, emojiId, res.data)
          }
        })
        .catch(err => {
          ;(this.$parent as any).handleTopicNotFound(err)
        })
        .finally(() => this.$blockui.hide())
    }
  }

  /**
   * Handle after call API like or dislike topic
   */
  handleAfterLikeComment(
    currentCmt: TopicComment,
    emojiId: string,
    data: {
      is_like: boolean
      hide_administrator: boolean
    }
  ) {
    const currentUser = this.$store.state.userInfo.user
    const userId = currentUser.info.id
    const existingIndex = currentCmt.liker.findIndex(
      (item: any) => item.id === userId
    )

    currentCmt.is_like = data.is_like

    if (data.is_like) {
      if (existingIndex === -1) {
        // add new liker
        const newLiker = new TopicLiker({
          id: userId,
          liker_name: currentUser.info.name,
          avatar: currentUser.profile.avatar_small,
          emoji_id: emojiId,
          hide_administrator: data.hide_administrator,
          user_active_status: EUserStatus.NORMAL
        })
        currentCmt.liker = [newLiker, ...currentCmt.liker]
      } else {
        // update emoji_id
        currentCmt.liker[existingIndex].emoji_id = emojiId
      }
    } else if (existingIndex !== -1) {
      currentCmt.liker.splice(existingIndex, 1)
    }
  }

  /**
   * Toggle comment reply collapse
   */
  async toggleReplyCollapse(id: number) {
    if (this.replyCommentId === id) {
      //close collapse
      this.replyCommentIdCollapse = 0
      setTimeout(() => (this.replyCommentId = 0), 100)
    } else {
      //open collapse
      this.replyCommentId = id
      setTimeout(() => {
        this.replyCommentIdCollapse = id

        //scroll and focus
        let el = document.getElementById(`commentBox-${id}`)
        globalThis.setTimeout(() => {
          ;(el as HTMLElement).scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'center'
          })
          ;(el as HTMLElement).focus()
        }, 0)
      }, 100)
    }
  }

  /**
   * Call API to submit comment reply
   */
  submitNewComment(newComment: TopicCommentParams, cmtId?: number) {
    let formData = new FormData()
    formData.set('topic_id', String(this.$route.params.topicId))
    formData.set('content_comment', newComment.content_comment)
    formData.set('content_text', stripHtmlKeepFormat(newComment.content_comment_text))  
    if (cmtId) {
      formData.set('comment_id', String(cmtId))
    }
    //for tiny editor
    newComment.tiny_file_ids.forEach(id => {
      formData.append('file_ids[]', String(id))
    })

    const mentionAllId = allItemMention.id.toString()
    const uniqueMentionsIds = getMentionIdsFromContent(newComment.content_comment)
    if (uniqueMentionsIds.length > 0) {
      uniqueMentionsIds.filter(id => id !== mentionAllId).forEach(id => {
        formData.append('user_ids[]', id)
      })
      if (uniqueMentionsIds.includes(mentionAllId)) {
        formData.set('mention_all', 'true')
      }
    }

    //attach file
    if (newComment.attach_file) {
      newComment.attach_file.forEach((file: File) => {
        formData.append('attach_file[]', file)
      })
    }
    this.$blockui.show()
    if (this.isCommonTopic) {
      CommonTopicService.addNewCommonTopicComment(formData)
        .then(res => {
          if (res.status === 201) {
            this.justSubmitNewComment = true

            //close collape
            this.replyCommentId = 0
            if (!cmtId) {
              (this.$refs as any).commentBoxParent.clearComment()
            }
          }
        })
        .catch(err => {
          this.$emit('addCommentError', err)
        })
        .finally(() => this.$blockui.hide())
    } else {
      GroupTopicService.addNewComment(this.$route.params.groupId, formData)
        .then(res => {
          if (res.status === 201) {
            this.justSubmitNewComment = true

            //close collape
            this.replyCommentId = 0

            if (!cmtId) {
              (this.$refs as any).commentBoxParent.clearComment()
            }
          }
        })
        .catch(err => {
          this.$emit('addCommentError', err)
        })
        .finally(() => this.$blockui.hide())
    }
  }

  /**
   * Open comfirm delete comment
   */
  openConfirm(commentId: number) {
    this.$emit('confirmDelCmt', commentId)
  }

  /**
   * Open modal liker
   */
  openLikerModal(index: number) {
    this.$bvModal.show(`comment-liker-list-${index}`)
  }

  /**
   * Format date
   */
  formatDate(date: string) {
    return FormatDate.formatFullDatetime(date)
  }

  /**
   * Show commenter profile modal
   */
  async showCommenterProfile(comment: TopicComment) {
    if (comment.user_active_status !== EUserStatus.NORMAL) return
    const userId = comment.commenter_id
    if (!this.allowAnonymous) {
      this.commenterId = userId      
      this.$bvModal.show('commenter-profile')
      // }
    }
  }

  /**
   * Check user is same group tag
   */
  // async getUserProfileById() {
  //   return UserService.getUserProfileById(this.commenterId)
  //     .then(res => {
  //       return res.status === 200 && res.data.is_same_group_tag
  //     })
  //     .catch(() => {
  //       return false
  //     })
  // }

  /**
   * Handle long text
   */
  handleLongText(text: string, max?: number) {
    return PreviewText.covertToPreviewText(text || '', max)
  }

  /**
   * Call API to get download files stream
   */
  downloadFile(file: TopicAttachFile) {
    //handle dowload IOS not safari
    if (
      CheckDevice.iOSBrowerName().toLowerCase() !== CheckDevice.safari &&
      CheckDevice.isMobile() &&
      CheckDevice.getMobileOS() === CheckDevice.ios
    ) {
      window.open(file.path)
      return
    }

    //download other
    // 画面全体はブロックせず、右下に進捗とキャンセルを出す（NWS_SMILELINE-1936）
    // HTTP エラー（掲示板が消えた 404 など）は従来どおり親画面のダイアログで知らせる。
    // タイムアウト・通信失敗は runDownload が右下に文言を出す
    const groupId = this.$route.params.groupId
    runDownload(
      downloadLabel([file.name]),
      config =>
        this.isCommonTopic
          ? CommonSharedFolderService.downloadCommonFiles([file.id], config)
          : GroupService.downloadFiles(groupId, [file.id], config),
      {
        key: `${this.isCommonTopic ? 'common' : `group-${groupId}`}-files:${file.id}`,
        // 応答が返る前に画面を離れていたら、親画面のダイアログは出さない
        owner: this,
        handleHttpError: err => {
          ;(this.$parent as any).handleTopicNotFound(err)
          return true
        }
      }
    ).then(res => {
      if (res && res.status === 200) {
        this.hanldeDownloadFile(res, file)
      }
    })
  }

  hanldeDownloadFile(res: any, file: TopicAttachFile) {
    const bytes = new Uint8Array(res.data)
    const blob = new Blob([bytes], { type: '*' })
    let a = document.createElement('a')
    const url = globalThis.URL.createObjectURL(blob)
    a.href = url
    a.setAttribute('target', '_blank')
    a.setAttribute('download', file.name)
    document.body.appendChild(a)
    a.click()
    a.remove()
    revokeObjectUrlLater(url)
  }

  handleFileNameWithSize(attachFile: TopicAttachFile) {
    if (!attachFile.size) return this.handleLongText(attachFile.name, 40).text
    const bytes = Number(attachFile.size)
    let sizeText = '0 KB'
    if (bytes) {
      if (bytes < 1) {
        sizeText = '1 KB'
      } else {
        const k = 1024
        const sizes = ['KB', 'MB', 'GB', 'TB']
        const i = Math.floor(Math.log(bytes) / Math.log(k))
        sizeText =
          Number.parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
      }
    }
    return this.handleLongText(attachFile.name, 40).text + `(${sizeText})`
  }

  getFileFormat(extension: string) {
    return CheckFileFormat.getFileFormat(extension)
  }

  getFormatIconClass(extension: string) {
    return CheckFileFormat.getIconClassNameWithFileExtention(extension)
  }

  handleCommenterName(comment: TopicComment) {
    if (this.allowAnonymous || !comment.commenter_name) {
      return {
        name: this.$t('groups.new_feed.anonymous') as string,
        text: this.$t('groups.new_feed.anonymous') as string
      }
    }

    if (comment.hide_administrator) {
      return {
        name: this.$t('common.suffix.admin').toString(),
        text: this.$t('common.suffix.admin').toString()
      }
    }

    let text = hanldeUserStatus(
      comment.commenter_name,
      comment.user_active_status
    )
    const preview = PreviewText.covertToPreviewText(text)
    return {
      name: text,
      text: preview.text
    }
  }

  /**
   * Open full view for image file
   */
  fullOverview(src: string) {
    this.fullOverviewSrc = src
    this.canOpenFullImageModal = true
  }

  onInlineEditorImageClick(e: MouseEvent) {
    const root = e.currentTarget as HTMLElement
    const src = getInlineEditorImageSrcFromClick(e, root)
    if (!src) return
    e.preventDefault()
    e.stopPropagation()
    this.fullOverview(src)
  }

  jumpToParentComment(commentId?: number) {
    if (!commentId) return
    this.$router
      .replace({ query: { commentId: String(commentId) } })
      .catch(() => this.$bvModal.show('parent-comment-modal'))
  }

  handleLinkifyContent(processed = '') {
    processed = processed ?? ''
    // ブロックHTML(書式編集のTinyMCE / テキストモードの<div>行)は
    // 改行をタグ構造が担うため、素の\nは<br>化しない(本文と同挙動=段落二重化を防ぐ)。
    // ブロックが一切無い素テキスト(メンションのみ/プレーン文)のときだけ\n→<br>で可視化。
    // NWS-1755: 従来は全\n→<br>後に</block>直後の<br>1個だけ除去していたが、
    // 改行2連(</p>\n\n<p>)やShift+Enter(<br>\n)で余分な<br>が残り段落が二重化していた。
    const hasBlockHtml = /<(?:p|div|h[1-6]|ul|ol|li|blockquote|table)[\s>]/i.test(processed)
    if (!hasBlockHtml) {
      processed = processed.replace(/\r?\n/g, '<br>')
    }
    return linkifyHtml(processed, { target: '_blank' })
  }

  filterDeletedComment(commentId: number) {
    // filter comment has been deleted
    let deletedComment = this.currentComments.findIndex(comment =>
      comment.id == commentId
    )
    this.currentComments[deletedComment].is_deleted = true

    // filter child comment of deleted comment
    this.currentComments.forEach((item, index) => {
      if (item.comment_id == commentId) {
        this.currentComments[index].comment_parent_delete = true
      }
    })
  }

  mapReaderListModal(users: any[]) {
    return (users || []).map((item: any) => ({
      id: item.user_active_status ? -1 : item.id,
      avatar:
        item.user_active_status === EUserStatus.LEAVE_SYSTEM
          ? ''
          : item.avatar_small,
      liker_name: item.name,
      user_active_status: item.user_active_status,
      hide_administrator: item?.hide_administrator
    }))
  }

  shouldFetchFullUsersRead(comment: TopicComment) {
    return this.getCommentUsersReadTotal(comment) > this.maxUserDisplay
  }

  async openListReaderModal(comment: TopicComment) {
    this.readerListShowEmoji = false
    this.$bvModal.show('comment-reader-list')

    if (!this.shouldFetchFullUsersRead(comment)) {
      this.readerListLoading = false
      this.readerListModal = this.mapReaderListModal(comment.users_read)
      return
    }

    this.readerListModal = []
    this.readerListLoading = true

    try {
      const res = await GroupTopicService.getUserReadForComment(
        this.$route.params.groupId,
        this.$route.params.topicId,
        comment.id
      )
      if (res.status === 200) {
        this.readerListModal = this.mapReaderListModal(res.data?.data || [])
      }
    } catch {
      this.readerListModal = this.mapReaderListModal(comment.users_read)
    } finally {
      this.readerListLoading = false
    }
  }

   async onTranslateComment(index: number) {
    const item = this.currentComments[index]

    if (this.isDisabledTranslate(item)) {
      return
    }

    if (item.isTranslated) {
      item.isTranslated = false
      return
    }

    if (item.content_translation) {
      item.isTranslated = true
      return
    }

    const { doc, textNodes } = extractContentFromContentEditableOrTiny(
      item.content || ''
    )

    const q = textNodes.map(t => t.originalText)
    if (!q.length) return

    await handleTranslation({
      modalId: 'comment-translation-error-modal',
      q,
      onSuccess: async (res: any) => {
        const translations: string[] =
          res?.map((t: any) => decodeHtml(t.translatedText)) || []

        for (const node of textNodes) {
          const translated = translations.shift() || ''
          const indentHtml = node.indent.replaceAll(' ', '&nbsp;')

          const parent = node.node.parentNode as HTMLElement
          const span = document.createElement('span')
          span.innerHTML = indentHtml + escapeHtml(translated)

          parent.replaceChild(span, node.node)
        }

        item.isTranslated = true
        item.content_translation = doc.body.innerHTML

        return {
          target_id: item.id,
          topic_id: Number(this.$route.params.topicId),
          type: TRANSLATION_TYPE.TOPIC_COMMENT,
          content_translation: doc.body.innerHTML
        }
      },
      onError: (message: string) => {
        this.errorMess = message
      },
    })
  }

  updateCurrentComments(data: TopicComment[]) {
    this.currentComments = data
  }

  getCurrentComments() {
    return this.currentComments
  }

  resetTranslations() {
    this.currentComments = this.currentComments.map(c => ({
    ...c,
    isTranslated: false,
    content_translation: ''
  }))
  }

  getEmojiByNative(nativeChar: string) {
    return getEmojiByNativeFunc(nativeChar, this.emojiIndex)
  }

  getDisplayCommentLikers(comment: TopicComment) {
    return (comment?.liker || []).slice(0, this.maxUserDisplay)
  }

  getCommentLikerRemainCount(comment: TopicComment) {
    const total = (comment?.liker || []).length
    return Math.max(total - this.maxUserDisplay, 0)
  }

  getCommentUsersReadTotal(comment: TopicComment) {
    return comment.total_users_read || comment.users_read?.length || 0
  }

  /** 既読数をクリックしたとき。会社からのお知らせは匿名表示のため一覧を開かない */
  onClickCommentRead(comment: TopicComment) {
    if (this.isCommonTopic) return
    this.openListReaderModal(comment)
  }

  getDisplayCommentUsersRead(comment: TopicComment) {
    return (comment?.users_read || []).slice(0, this.maxUserDisplay)
  }

  getCommentUsersReadRemainCount(comment: TopicComment) {
    const total = this.getCommentUsersReadTotal(comment)
    const remainFromTotal = Math.max(total - this.maxUserDisplay, 0)
    if (comment.total_users_read != null) {
      return remainFromTotal
    }
    return (
      (comment.users_read_subtract || 0) +
      Math.max((comment.users_read?.length || 0) - this.maxUserDisplay, 0)
    )
  }

  isAllowShowUserProfile({
    comment,
    checkStatus = false
  }: {
    comment: TopicComment
    checkStatus?: boolean
  }) {
    const allowToShowProfile =
      !comment.is_deleted && !comment.hide_administrator && !this.allowAnonymous
    const isUserActive = comment.user_active_status === EUserStatus.NORMAL

    if (!checkStatus) {
      return allowToShowProfile
    }

    return allowToShowProfile && isUserActive
  }
}
